import { render, staticRenderFns } from "./handoff-notification-card.vue?vue&type=template&id=01d97d8b&scoped=true&"
import script from "./handoff-notification-card.vue?vue&type=script&lang=js&"
export * from "./handoff-notification-card.vue?vue&type=script&lang=js&"
import style0 from "./handoff-notification-card.vue?vue&type=style&index=0&id=01d97d8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d97d8b",
  null
  
)

export default component.exports